import { render, staticRenderFns } from "./pasargad.vue?vue&type=template&id=17d5a035"
import script from "./pasargad.vue?vue&type=script&lang=js"
export * from "./pasargad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports